import { render, staticRenderFns } from "./MRVoidButton.vue?vue&type=template&id=5f18f3cc"
import script from "./MRVoidButton.vue?vue&type=script&lang=ts"
export * from "./MRVoidButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports